(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sh-all-categories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function norm(s) {
      return (s || '')
        .toLowerCase()
        .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
        .replace(/[^a-z0-9 ]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function init(root) {
      if (!root || root.dataset.shCatsReady) return;
      root.dataset.shCatsReady = '1';

      var bar = root.querySelector('[data-sh-cats-bar]');
      var chipsWrap = root.querySelector('[data-sh-cats-chips]');
      var chips = Array.prototype.slice.call(root.querySelectorAll('[data-sh-cats-chip]'));
      var groups = Array.prototype.slice.call(root.querySelectorAll('[data-sh-cats-group]'));
      var input = root.querySelector('[data-sh-cats-search]');
      var empty = root.querySelector('[data-sh-cats-empty]');

      /* Chips for groups that rendered nothing (all empty) go too */
      chips.forEach(function (chip) {
        if (!document.getElementById(chip.dataset.shCatsChip)) chip.hidden = true;
      });

      groups.forEach(function (group) {
        group._tiles = Array.prototype.slice.call(group.querySelectorAll('[data-sh-cats-tile]'));
        group._tiles.forEach(function (tile) { tile._text = norm(tile.dataset.search); });
        group._title = norm(group.querySelector('.sh-cats__group-title').textContent);
      });

      function markLast() {
        groups.forEach(function (group) {
          var visible = group._tiles.filter(function (t) { return !t.hidden; });
          group._tiles.forEach(function (t) { t.classList.remove('is-last'); });
          if (visible.length) visible[visible.length - 1].classList.add('is-last');
        });
      }

      function setFade() {
        if (!chipsWrap) return;
        var max = chipsWrap.scrollWidth - chipsWrap.clientWidth;
        chipsWrap.classList.toggle('is-overflow-start', max > 1 && chipsWrap.scrollLeft > 1);
        chipsWrap.classList.toggle('is-overflow-end', max > 1 && chipsWrap.scrollLeft < max - 1);
      }

      if (chipsWrap) {
        chipsWrap.addEventListener('scroll', setFade, { passive: true });
      }

      function setBarHeight() {
        if (bar) root.style.setProperty('--sh-cats-bar', bar.offsetHeight + 'px');
      }

      function setActive(id) {
        chips.forEach(function (chip) {
          var on = chip.dataset.shCatsChip === id;
          chip.classList.toggle('is-active', on);
          if (on && chipsWrap.scrollWidth > chipsWrap.clientWidth) {
            chipsWrap.scrollTo({ left: chip.offsetLeft - 16, behavior: 'smooth' });
          }
        });
      }

      /* Search: filters tiles live, hides groups without hits, URL stays */
      if (input) {
        var mobilePlaceholder = input.dataset.placeholderMobile;
        var desktopPlaceholder = input.placeholder;
        var mq = window.matchMedia('(max-width: 749px)');
        var applyPlaceholder = function () {
          input.placeholder = mq.matches && mobilePlaceholder ? mobilePlaceholder : desktopPlaceholder;
        };
        applyPlaceholder();
        if (mq.addEventListener) mq.addEventListener('change', applyPlaceholder);

        input.addEventListener('input', function () {
          var terms = norm(input.value).split(' ').filter(Boolean);
          var anyHit = false;

          groups.forEach(function (group) {
            var groupHit = terms.length && terms.every(function (t) { return group._title.indexOf(t) > -1; });
            var hits = 0;
            group._tiles.forEach(function (tile) {
              var match = !terms.length || groupHit || terms.every(function (t) { return tile._text.indexOf(t) > -1; });
              tile.hidden = !match;
              if (match) hits++;
            });
            group.hidden = hits === 0;
            if (hits) anyHit = true;
          });

          chips.forEach(function (chip) {
            var g = document.getElementById(chip.dataset.shCatsChip);
            chip.hidden = !g || g.hidden;
          });

          if (empty) empty.hidden = anyHit;
          markLast();
        });
      }

      /* Jump chips: scroll to the group anchor and mark the chip */
      chips.forEach(function (chip) {
        chip.addEventListener('click', function (event) {
          var target = document.getElementById(chip.dataset.shCatsChip);
          if (!target) return;
          /* The theme scrolls #anchors itself, without our offset */
          event.preventDefault();
          event.stopPropagation();
          setBarHeight();
          lock = Date.now() + 900;
          setActive(chip.dataset.shCatsChip);

          /* Offset by hand: the theme header and the chip bar both stick */
          var stuckTop = bar ? parseFloat(getComputedStyle(bar).top) || 0 : 0;
          var barHeight = bar ? bar.offsetHeight : 0;
          var y = target.getBoundingClientRect().top + window.pageYOffset - stuckTop - barHeight - 16;
          window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
        });
      });

      /* The active chip follows the scroll position */
      var lock = 0;
      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          if (bar) {
            var stuckTop = parseFloat(getComputedStyle(bar).top) || 0;
            bar.classList.toggle('is-stuck', bar.getBoundingClientRect().top <= stuckTop + 0.5 && window.scrollY > 0);
          }
          if (Date.now() < lock) return;
          var line = (bar ? bar.getBoundingClientRect().bottom : 0) + 40;
          var current = null;
          groups.forEach(function (group) {
            if (!group.hidden && group.getBoundingClientRect().top <= line) current = group;
          });
          var first = groups.filter(function (g) { return !g.hidden; })[0];
          setActive((current || first || {}).id);
        });
      }

      setBarHeight();
      markLast();
      window.addEventListener('scroll', onScroll, { passive: true });
      setFade();
      window.addEventListener('resize', function () { setBarHeight(); setFade(); });
      onScroll();
    }

    function boot() {
      document.querySelectorAll('[data-sh-cats]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBar(bar) {
      if (!bar || bar.dataset.shAnnouncementReady === '1') return;
      bar.dataset.shAnnouncementReady = '1';

      var items = bar.querySelectorAll('[data-sh-announcement-item]');
      var timer = null;
      var index = 0;

      // Desktop lays every message out side by side, so there is nothing to
      // rotate there. Mobile always rotates.
      var desktopFlex = bar.getAttribute('data-desktop-flex') === '1';
      var desktopQuery = window.matchMedia('(min-width: 1000px)');

      function isFlexMode() {
        return desktopFlex && desktopQuery.matches;
      }

      function setHeight() {
        document.documentElement.style.setProperty('--announcement-bar-height', bar.clientHeight + 'px');
      }

      function show(next) {
        if (next === index) return;
        items[index].classList.remove('is-active');
        items[index].setAttribute('aria-hidden', 'true');
        index = next;
        items[index].classList.add('is-active');
        items[index].removeAttribute('aria-hidden');
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        stop();
        if (items.length < 2 || isFlexMode()) return;
        var delay = parseInt(bar.getAttribute('data-interval'), 10);
        if (!delay || delay < 1000) delay = 5000;
        timer = setInterval(function () {
          show((index + 1) % items.length);
        }, delay);
      }

      // Keep aria-hidden in step with what is actually on screen, and restart
      // or halt the timer when the viewport crosses the desktop breakpoint.
      function applyMode() {
        var flex = isFlexMode();
        for (var i = 0; i < items.length; i++) {
          if (flex || i === index) {
            items[i].removeAttribute('aria-hidden');
          } else {
            items[i].setAttribute('aria-hidden', 'true');
          }
        }
        start();
        setHeight();
      }

      applyMode();
      window.addEventListener('resize', setHeight);

      if (desktopQuery.addEventListener) {
        desktopQuery.addEventListener('change', applyMode);
      } else if (desktopQuery.addListener) {
        desktopQuery.addListener(applyMode);
      }

      // Pause while the visitor is reading it, and while the tab is hidden.
      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stop();
        } else {
          start();
        }
      });

      bar.shAnnouncement = { show: show, stop: stop, start: start, items: items, isFlexMode: isFlexMode };
    }

    function initAll(scope) {
      var root = scope || document;
      var bars = root.querySelectorAll('[data-sh-announcement]');
      for (var i = 0; i < bars.length; i++) initBar(bars[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    // Theme editor support.
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var bar = event.target.closest ? event.target.closest('[data-sh-announcement]') : null;
      if (!bar || !bar.shAnnouncement) return;
      if (bar.shAnnouncement.isFlexMode()) return;
      var items = bar.shAnnouncement.items;
      for (var i = 0; i < items.length; i++) {
        if (items[i] === event.target || items[i].contains(event.target)) {
          bar.shAnnouncement.stop();
          bar.shAnnouncement.show(i);
          return;
        }
      }
    });

    document.addEventListener('shopify:block:deselect', function (event) {
      var bar = event.target.closest ? event.target.closest('[data-sh-announcement]') : null;
      if (bar && bar.shAnnouncement) bar.shAnnouncement.start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-cross-sell"] && !Shopify.designMode) return;
  try {
    
  (function () {
      function initCrossSell(root) {
        if (!root || root.dataset.scsReady === '1') return;
        var track = root.querySelector('[data-scs-track]');
        if (!track) return;
        root.dataset.scsReady = '1';

        function maxScroll() {
          return track.scrollWidth - track.clientWidth;
        }

        /* Click & drag to slide */
        var isDown = false;
        var moved = false;
        var startX = 0;
        var startScroll = 0;
        var pointerId = null;

        track.addEventListener('pointerdown', function (e) {
          if (e.button !== 0) return;
          if (maxScroll() <= 4) return;
          isDown = true;
          moved = false;
          startX = e.clientX;
          startScroll = track.scrollLeft;
          pointerId = e.pointerId;
          track.classList.add('is-dragging');
        });

        track.addEventListener('pointermove', function (e) {
          if (!isDown) return;
          var dx = e.clientX - startX;
          if (Math.abs(dx) > 3) moved = true;
          track.scrollLeft = startScroll - dx;
          e.preventDefault();
        });

        function endDrag() {
          if (!isDown) return;
          isDown = false;
          track.classList.remove('is-dragging');
          pointerId = null;
        }

        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);
        track.addEventListener('pointerleave', endDrag);

        /* Swallow the click that follows a real drag so links don't navigate */
        track.addEventListener(
          'click',
          function (e) {
            if (moved) {
              e.preventDefault();
              e.stopPropagation();
              moved = false;
            }
          },
          true
        );
      }

      function boot() {
        document.querySelectorAll('[data-sh-cross-sell]').forEach(initCrossSell);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
      } else {
        boot();
      }

      document.addEventListener('shopify:section:load', boot);
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-faq-split"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.shFaqSplit) {
      window.shFaqSplit = {
        init: function (root) {
          if (!root || root.dataset.shReady === 'true') return;
          root.dataset.shReady = 'true';

          /* Fallback for browsers without exclusive <details name> support */
          root.addEventListener(
            'toggle',
            function (event) {
              var item = event.target;
              if (!item.open || !root.hasAttribute('data-single-open')) return;
              root.querySelectorAll('.sh-faq-split__item[open]').forEach(function (other) {
                if (other !== item) other.open = false;
              });
            },
            true
          );
        },
        initAll: function () {
          document.querySelectorAll('[data-sh-faq-split]').forEach(function (root) {
            window.shFaqSplit.init(root);
          });
        }
      };

      document.addEventListener('shopify:section:load', function (event) {
        window.shFaqSplit.init(event.target.querySelector('[data-sh-faq-split]'));
      });

      document.addEventListener('shopify:block:select', function (event) {
        var item = event.target && event.target.closest ? event.target.closest('.sh-faq-split__item') : null;
        if (item) item.open = true;
      });
    }

    window.shFaqSplit.initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('sh-hero-slider')) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    class ShHeroSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-sh-track]');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-sh-slide]'));
        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-sh-dot]'));
        this.prevButton = this.querySelector('[data-sh-prev]');
        this.nextButton = this.querySelector('[data-sh-next]');
        this.count = this.slides.length;
        this.index = 0;
        this.delay = Math.max(2, parseFloat(this.dataset.speed) || 6) * 1000;
        this.autoplay = this.dataset.autoplay === 'true' && this.count > 1;
        this.hovered = false;
        this.focused = false;
        this.stopped = false;
        this.editorHold = false;
        this.timer = null;
        this.controller = new AbortController();

        if (!this.track || this.count < 2) return;

        var signal = this.controller.signal;
        var self = this;

        if (this.prevButton) {
          this.prevButton.addEventListener('click', function () {
            self.stop();
            self.goTo(self.index - 1);
          }, { signal: signal });
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', function () {
            self.stop();
            self.goTo(self.index + 1);
          }, { signal: signal });
        }

        this.dots.forEach(function (dot, i) {
          dot.addEventListener('click', function () {
            self.stop();
            self.goTo(i);
          }, { signal: signal });
        });

        this.addEventListener('keydown', this.onKeydown.bind(this), { signal: signal });

        this.addEventListener('mouseenter', function () {
          self.hovered = true;
          self.schedule();
        }, { signal: signal });
        this.addEventListener('mouseleave', function () {
          self.hovered = false;
          self.schedule();
        }, { signal: signal });
        this.addEventListener('focusin', function () {
          self.focused = true;
          self.schedule();
        }, { signal: signal });
        this.addEventListener('focusout', function (event) {
          if (!self.contains(event.relatedTarget)) {
            self.focused = false;
            self.schedule();
          }
        }, { signal: signal });

        document.addEventListener('visibilitychange', function () {
          self.schedule();
        }, { signal: signal });

        if (reducedMotion.addEventListener) {
          reducedMotion.addEventListener('change', function () {
            self.schedule();
          }, { signal: signal });
        }

        /* Swipe (touch / pen only, vertical scrolling stays native via touch-action: pan-y) */
        this.track.addEventListener('pointerdown', this.onPointerDown.bind(this), { signal: signal });
        this.track.addEventListener('pointerup', this.onPointerUp.bind(this), { signal: signal });
        this.track.addEventListener('pointercancel', function () {
          self.pointer = null;
        }, { signal: signal });
        this.track.addEventListener('click', function (event) {
          if (self.suppressClick) {
            event.preventDefault();
            event.stopPropagation();
            self.suppressClick = false;
          }
        }, { capture: true, signal: signal });

        /* Theme editor */
        document.addEventListener('shopify:block:select', function (event) {
          var slide = event.target && event.target.closest ? event.target.closest('[data-sh-slide]') : null;
          var i = slide ? self.slides.indexOf(slide) : -1;
          if (i === -1) return;
          self.editorHold = true;
          self.goTo(i, true);
        }, { signal: signal });
        document.addEventListener('shopify:block:deselect', function (event) {
          if (self.contains(event.target)) {
            self.editorHold = false;
            self.schedule();
          }
        }, { signal: signal });

        this.goTo(0, true);
      }

      disconnectedCallback() {
        this.clearTimer();
        if (this.controller) this.controller.abort();
      }

      goTo(target, instant) {
        var self = this;
        var next = ((target % this.count) + this.count) % this.count;
        this.index = next;

        if (instant) this.classList.add('is-instant');
        this.track.style.setProperty('--shs-index', String(next));

        this.slides.forEach(function (slide, i) {
          var active = i === next;
          slide.classList.toggle('is-active', active);
          if (active) {
            slide.removeAttribute('aria-hidden');
            slide.removeAttribute('inert');
          } else {
            slide.setAttribute('aria-hidden', 'true');
            slide.setAttribute('inert', '');
          }
        });

        this.dots.forEach(function (dot, i) {
          var active = i === next;
          dot.classList.toggle('is-active', active);
          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });

        this.classList.toggle('is-dark', this.slides[next].dataset.theme === 'dark');

        if (instant) {
          /* force reflow, then re-enable transitions */
          void this.track.offsetWidth;
          window.requestAnimationFrame(function () {
            self.classList.remove('is-instant');
          });
        }

        this.schedule();
      }

      canAutoplay() {
        return this.autoplay &&
          !this.stopped &&
          !this.hovered &&
          !this.focused &&
          !this.editorHold &&
          !document.hidden &&
          !reducedMotion.matches;
      }

      schedule() {
        var self = this;
        this.clearTimer();
        var running = this.canAutoplay();
        this.track.setAttribute('aria-live', running ? 'off' : 'polite');
        if (running) {
          this.timer = window.setTimeout(function () {
            self.goTo(self.index + 1);
          }, this.delay);
        }
      }

      clearTimer() {
        if (this.timer) {
          window.clearTimeout(this.timer);
          this.timer = null;
        }
      }

      /* Manual navigation ends autoplay for this page view */
      stop() {
        this.stopped = true;
        this.clearTimer();
      }

      onKeydown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        var target = event.target;
        var isControl = target === this.prevButton || target === this.nextButton || this.dots.indexOf(target) !== -1;
        if (!isControl) return;
        event.preventDefault();
        this.stop();
        this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        if (this.dots.indexOf(target) !== -1 && this.dots[this.index]) {
          this.dots[this.index].focus();
        }
      }

      onPointerDown(event) {
        if (event.pointerType === 'mouse') return;
        this.pointer = { x: event.clientX, y: event.clientY };
      }

      onPointerUp(event) {
        if (!this.pointer) return;
        var dx = event.clientX - this.pointer.x;
        var dy = event.clientY - this.pointer.y;
        this.pointer = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        this.suppressClick = true;
        var self = this;
        window.setTimeout(function () {
          self.suppressClick = false;
        }, 350);
        this.stop();
        this.goTo(this.index + (dx < 0 ? 1 : -1));
      }
    }

    customElements.define('sh-hero-slider', ShHeroSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-home-seo-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!window.shSeoText) {
      var mq = window.matchMedia('(max-width: 749px)');

      window.shSeoText = {
        update: function (root) {
          var body = root.querySelector('.sh-seo-text__body');
          if (!body || !mq.matches) return;
          var limit = parseFloat(root.getAttribute('data-collapsed-height')) || 220;
          root.classList.toggle('is-collapsible', body.scrollHeight > limit + 40);
        },
        init: function (root) {
          if (!root || root.dataset.shReady === 'true' || !root.hasAttribute('data-collapse-mobile')) return;
          root.dataset.shReady = 'true';

          var toggle = root.querySelector('.sh-seo-text__toggle');
          window.shSeoText.update(root);
          if (!toggle) return;

          var label = toggle.querySelector('.sh-seo-text__toggle-label');
          toggle.addEventListener('click', function () {
            var expanded = !root.classList.contains('is-expanded');
            root.classList.toggle('is-expanded', expanded);
            toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            if (label) {
              label.textContent = toggle.getAttribute(expanded ? 'data-label-less' : 'data-label-more');
            }
            if (!expanded && root.getBoundingClientRect().top < 0) {
              root.scrollIntoView({ block: 'start' });
            }
          });
        },
        updateAll: function () {
          document.querySelectorAll('[data-sh-seo-text][data-sh-ready="true"]').forEach(function (root) {
            window.shSeoText.update(root);
          });
        },
        initAll: function () {
          document.querySelectorAll('[data-sh-seo-text]').forEach(function (root) {
            window.shSeoText.init(root);
          });
        }
      };

      if (mq.addEventListener) {
        mq.addEventListener('change', window.shSeoText.updateAll);
      } else if (mq.addListener) {
        mq.addListener(window.shSeoText.updateAll);
      }

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(window.shSeoText.updateAll, 150);
      });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(window.shSeoText.updateAll);
      }

      document.addEventListener('shopify:section:load', function (event) {
        window.shSeoText.init(event.target.querySelector('[data-sh-seo-text]'));
      });
    }

    window.shSeoText.initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-product-highlights"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMedia(media) {
      if (!media || media.dataset.shHighlightsReady === '1') return;
      media.dataset.shHighlightsReady = '1';

      var play = media.querySelector('button.sh-highlights__play');
      if (!play) return;

      var video = null;

      function sync() {
        if (video) play.hidden = !video.paused;
      }

      play.addEventListener('click', function () {
        var src = media.getAttribute('data-video-src');
        if (!src) return;
        if (!video) {
          video = document.createElement('video');
          video.src = src;
          video.controls = true;
          video.playsInline = true;
          media.appendChild(video);
          video.addEventListener('play', sync);
          video.addEventListener('pause', sync);
          video.addEventListener('ended', sync);
        }
        video.play();
      });
    }

    function boot() {
      document.querySelectorAll('[data-sh-highlights-media]').forEach(initMedia);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements.get('sh-product-tabs')) return;

    class ShProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
        if (!this.tabs.length) return;

        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', this.handleClick);
          tab.addEventListener('keydown', this.handleKeydown);
        });
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
      }

      disconnectedCallback() {
        if (!this.tabs) return;
        this.tabs.forEach((tab) => {
          tab.removeEventListener('click', this.handleClick);
          tab.removeEventListener('keydown', this.handleKeydown);
        });
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }

      handleClick(event) {
        this.select(event.currentTarget, false);
      }

      handleKeydown(event) {
        const index = this.tabs.indexOf(event.currentTarget);
        const last = this.tabs.length - 1;
        let next = null;

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            next = index === last ? 0 : index + 1;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            next = index === 0 ? last : index - 1;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = last;
            break;
          default:
            return;
        }

        event.preventDefault();
        this.select(this.tabs[next], true);
      }

      handleBlockSelect(event) {
        const blockId = event.detail && event.detail.blockId;
        if (!blockId) return;
        const tab = this.tabs.find((item) => item.dataset.blockId === blockId);
        if (tab) this.select(tab, false);
      }

      select(tab, focus) {
        this.tabs.forEach((item) => {
          const active = item === tab;
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.setAttribute('tabindex', active ? '0' : '-1');
          if (panel) panel.hidden = !active;
        });

        if (focus) tab.focus();

        // Keep the active tab visible inside the horizontally scrollable tab bar
        const wrap = tab.closest('.sh-product-tabs__tabs-wrap');
        if (wrap && wrap.scrollWidth > wrap.clientWidth) {
          const wrapRect = wrap.getBoundingClientRect();
          const tabRect = tab.getBoundingClientRect();
          if (tabRect.left < wrapRect.left) {
            wrap.scrollLeft -= wrapRect.left - tabRect.left + 16;
          } else if (tabRect.right > wrapRect.right) {
            wrap.scrollLeft += tabRect.right - wrapRect.right + 16;
          }
        }
      }
    }

    window.customElements.define('sh-product-tabs', ShProductTabs);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function starSpans(rating) {
      var html = '';
      for (var i = 1; i <= 5; i++) {
        var cls = 'shr-star';
        if (rating >= i) cls += ' is-full';
        else if (rating >= i - 0.5) cls += ' is-half';
        html += '<span class="' + cls + '"></span>';
      }
      return html;
    }

    function esc(s) {
      var d = document.createElement('div');
      d.textContent = s == null ? '' : String(s);
      return d.innerHTML;
    }
    // Judge.me returns some fields HTML-encoded ("&amp;"); decode to plain text.
    function decode(s) {
      var t = document.createElement('textarea');
      t.innerHTML = s == null ? '' : String(s);
      return t.value;
    }

    function relTime(iso) {
      var then = new Date(iso), now = new Date();
      var days = Math.floor((now - then) / 86400000);
      if (isNaN(days)) return '';
      if (days <= 0) return 'Heute';
      if (days === 1) return 'Vor 1 Tag';
      if (days < 7) return 'Vor ' + days + ' Tagen';
      if (days < 14) return 'Vor 1 Woche';
      if (days < 30) return 'Vor ' + Math.floor(days / 7) + ' Wochen';
      if (days < 60) return 'Vor 1 Monat';
      if (days < 365) return 'Vor ' + Math.floor(days / 30) + ' Monaten';
      if (days < 730) return 'Vor 1 Jahr';
      return 'Vor ' + Math.floor(days / 365) + ' Jahren';
    }

    var MAX_LINES = 5;
    function bodyMaxHeight(body) {
      var lh = parseFloat(getComputedStyle(body).lineHeight) || 20;
      return lh * MAX_LINES + 2;
    }
    function makeToggle(label, onClick) {
      var el = document.createElement('span');
      el.className = 'sh-reviews__more';
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.textContent = label;
      el.addEventListener('click', onClick);
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); }
      });
      return el;
    }
    // Truncate a body to MAX_LINES with an inline "… More" toggle (needs layout).
    function setupBody(body) {
      var full = body.getAttribute('data-full') || (body.textContent || '').trim();
      body.setAttribute('data-full', full);
      body.textContent = full;
      var maxH = bodyMaxHeight(body);
      if (body.scrollHeight <= maxH) return; // fits — no More needed
      var words = full.split(/\s+/);
      var lo = 1, hi = words.length, best = 1;
      while (lo <= hi) {
        var mid = (lo + hi) >> 1;
        // measure WITH the "More" toggle so it stays inline on the last line
        body.innerHTML = esc(words.slice(0, mid).join(' ')) + '… <span class="sh-reviews__more">More</span>';
        if (body.scrollHeight <= maxH) { best = mid; lo = mid + 1; } else { hi = mid - 1; }
      }
      body.innerHTML = esc(words.slice(0, best).join(' ')) + '… ';
      body.appendChild(makeToggle('More', function () { expandBody(body); }));
    }
    function expandBody(body) {
      body.textContent = (body.getAttribute('data-full') || '') + ' ';
      body.appendChild(makeToggle('Weniger', function () { setupBody(body); }));
    }

    function getData(pid) {
      try {
        return window.jdgm && jdgm.data && jdgm.data.reviewWidget && jdgm.data.reviewWidget[pid];
      } catch (e) { return null; }
    }

    function render(root, data) {
      var ui = root.querySelector('[data-shr-ui]');
      if (!ui) return;

      var avg = parseFloat(data.average_rating) || 0;
      var count = data.number_of_reviews || 0;

      /*
       * No reviews yet → hide the whole section instead of showing an empty
       * 0,0 summary. Kept visible in the theme editor so it stays selectable.
       */
      if (count === 0 && !(data.reviews || []).length) {
        if (!(window.Shopify && Shopify.designMode)) {
          root.hidden = true;
          return;
        }
      }

      root.querySelector('[data-shr-avg]').textContent = avg.toFixed(1).replace('.', ',');
      root.querySelector('[data-shr-sum-stars]').innerHTML = starSpans(avg);
      root.querySelector('[data-shr-count]').textContent =
        count + ' ' + (count === 1 ? 'Bewertung' : 'Bewertungen');

      // Histogram 5 → 1
      var hist = data.histogram || [];
      var histHtml = '';
      hist.forEach(function (h) {
        histHtml +=
          '<div class="sh-reviews__hbar">' +
            '<span class="sh-reviews__hbar-label">' + h.rating + '</span>' +
            '<span class="sh-reviews__hbar-track"><span class="sh-reviews__hbar-fill" style="width:' + (h.percentage || 0) + '%"></span></span>' +
            '<span class="sh-reviews__hbar-count">' + (h.frequency || 0) + '</span>' +
          '</div>';
      });
      root.querySelector('[data-shr-hist]').innerHTML = histHtml;

      // Cards
      var reviews = data.reviews || [];
      var track = root.querySelector('[data-shr-track]');
      var cards = '';
      // On: badge on every card. Off: only where Judge.me reports a verified buyer.
      var alwaysVerified = root.getAttribute('data-always-verified') === 'true';
      reviews.forEach(function (r) {
        var initial = (r.reviewer_initial || (r.reviewer_name || '?').charAt(0)).toUpperCase();
        var verified = alwaysVerified || r.verified_buyer
          ? '<span class="sh-reviews__verified"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12.5l4 4 10-10" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>Verifiziert</span>'
          : '';
        cards +=
          '<article class="sh-reviews__card">' +
            '<div class="sh-reviews__card-top">' +
              '<span class="sh-reviews__avatar">' + esc(initial) + '</span>' +
              '<div class="sh-reviews__meta">' +
                '<div class="sh-reviews__namerow"><span class="sh-reviews__name">' + esc(decode(r.reviewer_name)) + '</span>' + verified + '</div>' +
                '<div class="sh-reviews__starrow"><span class="sh-reviews__stars sh-reviews__stars--sm">' + starSpans(r.rating || 0) + '</span>' +
                  '<span class="sh-reviews__date">' + esc(relTime(r.created_at)) + '</span>' +
                '</div>' +
              '</div>' +
            '</div>' +
            (r.title ? '<p class="sh-reviews__card-title">' + esc(decode(r.title)) + '</p>' : '') +
            '<p class="sh-reviews__card-body">' + esc(decode(r.body)) + '</p>' +
          '</article>';
      });
      track.innerHTML = cards;

      var sk = root.querySelector('[data-shr-skeleton]');
      if (sk) sk.hidden = true;
      ui.hidden = false;

      // Bodies must be measured while visible → wait a frame for layout.
      requestAnimationFrame(function () {
        track.querySelectorAll('.sh-reviews__card-body').forEach(setupBody);
      });

      wireCarousel(root, track);
      wireWrite(root);
    }

    function wireCarousel(root, track) {
      var wrap = root.querySelector('.sh-reviews__cardswrap');
      var next = root.querySelector('[data-shr-next]');
      if (!wrap || !track) return;

      function maxScroll() { return track.scrollWidth - track.clientWidth; }
      function update() {
        var can = maxScroll() > 4 && track.scrollLeft < maxScroll() - 4;
        wrap.classList.toggle('can-next', can);
        if (next) next.hidden = !can;
      }

      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: 302, behavior: 'smooth' });
        });
      }
      track.addEventListener('scroll', update);
      window.addEventListener('resize', update);

      // drag
      var down = false, moved = false, sx = 0, ss = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.button !== 0 || maxScroll() <= 4) return;
        down = true; moved = false; sx = e.clientX; ss = track.scrollLeft;
        wrap.classList.add('is-dragging');
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (Math.abs(dx) > 3) moved = true;
        track.scrollLeft = ss - dx;
        e.preventDefault();
      });
      function end() { if (down) { down = false; wrap.classList.remove('is-dragging'); } }
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
      track.addEventListener('pointerleave', end);
      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);

      update();
    }

    function wireWrite(root) {
      var btn = root.querySelector('[data-shr-write]');
      var src = root.querySelector('[data-shr-source]');
      if (!btn || btn.dataset.wired === '1') return;
      btn.dataset.wired = '1';
      btn.addEventListener('click', function () {
        var link = src && src.querySelector(
          '.jdgm-write-rev-link, .jm-write-review-button, .jm-action-buttons__button, [data-write-review], .jdgm-write-review-link'
        );
        if (link) link.click();
      });
    }

    function boot(root) {
      if (!root || root.dataset.shrReady === '1') return;
      var pid = root.getAttribute('data-product-id');
      var tries = 0;
      (function poll() {
        var data = getData(pid);
        if (data) {
          root.dataset.shrReady = '1';
          render(root, data);
          return;
        }
        if (tries++ < 50) { setTimeout(poll, 150); return; }
        // Data never arrived → graceful fallback: drop the skeleton and
        // reveal the (otherwise hidden) Judge.me widget so reviews still show.
        root.dataset.shrReady = '1';
        var sk = root.querySelector('[data-shr-skeleton]');
        if (sk) sk.hidden = true;
        var src = root.querySelector('[data-shr-source]');
        if (src) src.classList.add('is-visible');
      })();
    }

    function init() {
      document.querySelectorAll('[data-sh-reviews]').forEach(boot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-set-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(cents) {
      return (cents / 100).toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' €';
    }

    function updateVariant(card) {
      var dataEl = card.querySelector('.sh-set__variants');
      var check = card.querySelector('.sh-set__check');
      if (!dataEl || !check) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var selects = card.querySelectorAll('.sh-set__option');
      var chosen = {};
      selects.forEach(function (s) { chosen[s.dataset.position] = s.value; });

      var match = variants.filter(function (v) {
        return (!chosen['1'] || v.option1 === chosen['1']) &&
               (!chosen['2'] || v.option2 === chosen['2']) &&
               (!chosen['3'] || v.option3 === chosen['3']);
      })[0];

      var nowEl = card.querySelector('.sh-set__price-now');
      var cmpEl = card.querySelector('.sh-set__compare-item');

      if (!match) {
        check.disabled = true;
        card.classList.add('is-unavailable');
        return;
      }

      check.dataset.id = match.id;
      check.dataset.price = match.price;
      var hasCompare = match.compare_at_price && match.compare_at_price > match.price;
      check.dataset.compare = hasCompare ? match.compare_at_price : match.price;
      check.disabled = !match.available;
      card.classList.toggle('is-unavailable', !match.available);

      if (nowEl) nowEl.textContent = money(match.price);
      if (cmpEl) {
        if (hasCompare) {
          cmpEl.textContent = money(match.compare_at_price);
          cmpEl.hidden = false;
        } else {
          cmpEl.hidden = true;
        }
      }
    }

    function init(form) {
      if (!form || form.dataset.sstReady === '1') return;
      form.dataset.sstReady = '1';

      var checks = Array.prototype.slice.call(form.querySelectorAll('.sh-set__check'));
      var totalEl = form.querySelector('[data-sh-set-total]');
      var compareEl = form.querySelector('[data-sh-set-compare]');
      var savingsEl = form.querySelector('[data-sh-set-savings]');
      var savingsValEl = form.querySelector('[data-sh-set-savings-value]');
      var addBtn = form.querySelector('[data-sh-set-add]');

      function recompute() {
        var total = 0, compare = 0, count = 0;
        checks.forEach(function (c) {
          if (c.checked && !c.disabled) {
            total += parseInt(c.dataset.price, 10) || 0;
            compare += parseInt(c.dataset.compare, 10) || 0;
            count++;
          }
        });
        var savings = compare - total;
        totalEl.textContent = money(total);

        if (savings > 0) {
          compareEl.textContent = money(compare);
          compareEl.hidden = false;
          savingsValEl.textContent = money(savings);
          savingsEl.hidden = false;
        } else {
          compareEl.hidden = true;
          savingsEl.hidden = true;
        }
        addBtn.disabled = count === 0;
      }

      // Rows: click toggles the checkbox (ignore clicks inside the option selects)
      form.querySelectorAll('[data-sh-set-card]').forEach(function (card) {
        card.addEventListener('click', function (e) {
          if (e.target.closest('.sh-set__options')) return;
          var chk = card.querySelector('.sh-set__check');
          if (!chk || chk.disabled) return;
          chk.checked = !chk.checked;
          recompute();
        });

        var selects = card.querySelectorAll('.sh-set__option');
        if (!selects.length) return;
        selects.forEach(function (s) {
          s.addEventListener('change', function () {
            updateVariant(card);
            recompute();
          });
        });
        updateVariant(card); // sync initial data + price formatting
      });

      // Keyboard toggle on the (visually hidden) checkbox
      checks.forEach(function (c) {
        c.addEventListener('change', recompute);
      });

      addBtn.addEventListener('click', function () {
        var items = checks
          .filter(function (c) { return c.checked && !c.disabled; })
          .map(function (c) { return { id: parseInt(c.dataset.id, 10), quantity: 1 }; });
        if (!items.length) return;

        addBtn.disabled = true;
        var original = addBtn.textContent;
        addBtn.textContent = 'Wird hinzugefügt…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            // Fire the theme's own event so the mini-cart re-renders AND opens,
            // exactly like the PDP buy button (assets/theme.js _onProductAdded).
            addBtn.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                button: addBtn,
                variant: null,
                quantity: items.length,
                productAdded: true
              }
            }));
            addBtn.disabled = false;
            addBtn.textContent = original;
          })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.textContent = original;
          });
      });

      recompute();
    }

    function boot() {
      document.querySelectorAll('[data-sh-set]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
